import { NOTIFICATION_TYPE } from '@utils/constants/notification.constant';

export function NotificationIcon(
  type: number,
  additionalValue: string | number = '',
): string {
  switch (type) {
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_ADD:
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_WS_COMPLETE:
    case NOTIFICATION_TYPE.NOTIF_BUBBLES_ADJUSTMENT_FROM_ADMIN:
    case NOTIFICATION_TYPE.NOTIF_CHALLENGE_REWARD_SHARER:
    case NOTIFICATION_TYPE.NOTIF_CHALLENGE_REWARD_RECEIVER:
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_ONLINE_LESSON_REWARD:
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_PARENT_TRANSFER:
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_EXPIRED:
      return 'C5.svg';
    case NOTIFICATION_TYPE.NOTIF_WS_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIF_LEARNER_PROFILE_NEW_DA:
    case NOTIFICATION_TYPE.NOTIF_LEARNER_PROFILE_DA_REMINDER:
    case NOTIFICATION_TYPE.NOTIFICATION_STUDY_PLAN:
    case NOTIFICATION_TYPE.NOTIFICATION_DIAGNOSTIC_ASSESSMENT_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIFICATION_WS_HOMEWORK_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIF_ASSIGN_WS:
      return 'GS1.svg';
    case NOTIFICATION_TYPE.NOTIF_WS_MARKED:
      return 'GS3.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_INCREASED:
      return 'GS4.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_DECREASED:
    case NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_DECAYED:
      return 'GS5.svg';
    case NOTIFICATION_TYPE.NOTIF_CONCEPT_IMPROVEMENT:
      if (typeof additionalValue !== 'string' && additionalValue > 0) {
        return 'GS4.svg';
      }
      return 'GS5.svg';
    case NOTIFICATION_TYPE.NOTIF_WORKSHEET_DUE:
    case NOTIFICATION_TYPE.NOTIF_WS_REOPEN:
    case NOTIFICATION_TYPE.NOTIFICATION_REVISION_GROUP:
      return 'GS2.svg';
    case NOTIFICATION_TYPE.NOTIF_CHALLENGE_RECEIVED:
      return 'GS7.svg';
    case NOTIFICATION_TYPE.NOTIF_CHALLENGE_ACCEPTED:
    case NOTIFICATION_TYPE.NOTIF_CHALLENGE_COMPLETED:
    case NOTIFICATION_TYPE.NOTIF_CHALLENGE_RECEIVER_COMPLETED:
      return 'GS8.svg';
    case NOTIFICATION_TYPE.NOTIF_EXAM_RESULT:
    case NOTIFICATION_TYPE.NOTIF_EXAM_RESULT_REWARD:
      return 'C3.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_REMINDER_EXAM_RESULT:
      return 'C1.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_LEADERBOARD:
    case NOTIFICATION_TYPE.NOTIFICATION_NEW_LEADERBOARD_ENDED:
    case NOTIFICATION_TYPE.NOTIFICATION_NEW_LEADERBOARD_ENDING:
      return 'C4.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_STREAK_V2_NORMAL:
    case NOTIFICATION_TYPE.NOTIFICATION_STREAK_V2_SALVAGED:
    case NOTIFICATION_TYPE.NOTIFICATION_STREAK_V2_RESET:
      return 'GS6.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIEASK_PRIVATE_MESSAGE:
      return 'GA1.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIEASK_MENTION:
      return 'GA2.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_STUDENT_ADDED_TO_CLASS:
      return 'GA3.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_STUDENT_REMOVE_FROM_CLASS:
      return 'GA4.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIEASK_REPLY:
      return 'GA5.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIEASK_TEACHER_PINNED:
      return 'GA6.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_ONLINE_LESSON_START:
      return 'GC1.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_ONLINE_LESSON_UPCOMING:
      return 'GC5.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_PRECLASS:
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_POSTCLASS:
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_TO_GENIESMART:
      return 'GC2.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_PERFORMANCE:
      return 'GC4.svg';
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_WORKSHEET_ASSIGNED:
      return 'GS1.svg';
    default:
      return 'C1.svg';
  }
}
